export enum LogoutStatus {
  Idle = 'idle',
  InProgress = 'in-progress',
  Done = 'done',
}
